export const LOGO_URL='https://img.freepik.com/free-vector/delivery-service-illustrated_23-2148505081.jpg?ga=GA1.1.273618505.1698651423&semt=ais_hybrid';

export const CDN_URL='https://dineout-media-assets.swiggy.com/swiggy/image/upload/'

export const SWIGGY_API='https://www.swiggy.com/dapi/restaurants/search/v3?lat=20.2959847&lng=85.8246101&str=restaurants&trackingId=dc51a832-70ee-c5fe-5ffe-e5eba69a27d7&submitAction=ENTER&queryUniqueId=37060c32-3f8c-5784-403e-43076add24f8 '

export const MY_api='http://localhost:2345/data'

export const MENU_API='https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=20.2959847&lng=85.8246101&restaurantId='

export const GITHUB_API='https://api.github.com/users/rahul1227'


